import React, { HtmlHTMLAttributes } from 'react';
import { useAppSelector } from 'store/store-hooks';
import StartPageButtonIcons from './StartPageButtonIcons';

export type VerticalUIMascotProps = HtmlHTMLAttributes<HTMLImageElement> & {
  hideMascotTitle?: boolean;
};

const VerticalUIMascot: React.FC<VerticalUIMascotProps> = ({
  hideMascotTitle = false,
  ...rest
}) => {
  const { boothInfo, isVerticalScreen } = useAppSelector(
    (state) => state.booth,
  );

  if (!isVerticalScreen) return null;
  if (hideMascotTitle || !boothInfo?.VerticalTitleImageUrl) return null;

  return <StartPageButtonIcons />;
};

export default VerticalUIMascot;
